import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["answer", "chevron"];

    toggle(event) {
        const id = event.currentTarget.dataset.faqId;
        const answer = this.answerTargets.find((el) => el.id === id);
        const chevron = this.chevronTargets.find((el) => el.dataset.faqId === id);

        if (answer.classList.contains("hidden")) {
            answer.classList.remove("hidden");
            chevron.classList.add("rotate-180");
        } else {
            answer.classList.add("hidden");
            chevron.classList.remove("rotate-180");
        }
    }
}
